var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurnOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M7 8.38c.195 0 .327-.137.327-.338V3.18c0-.2-.132-.343-.328-.343-.19 0-.327.143-.327.343v4.863c0 .2.137.338.327.338zm0 5.254c2.827 0 5.169-2.341 5.169-5.17 0-1.564-.709-2.98-1.83-3.926-.343-.302-.818.18-.438.518.967.803 1.575 2.035 1.575 3.409 0 2.479-1.998 4.477-4.477 4.477s-4.476-1.998-4.476-4.477c0-1.374.613-2.6 1.575-3.41.38-.338-.096-.819-.44-.517C2.545 5.489 1.83 6.9 1.83 8.465c0 2.828 2.342 5.17 5.17 5.17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnOn);
export default __webpack_public_path__ + "static/media/turn-on.1984dfa7229847f75d24a8d53d951091.svg";
export { ForwardRef as ReactComponent };